export class ProspectSourceFilter {
    public IncludeInactive?: boolean;
}

export default ProspectSourceFilter;